export interface MoneyProps {
  value?: number;
  big?: boolean;
}

export function Money({ value, big = false }: MoneyProps) {
  const formatted = (value ?? 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <span style={{ fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum"' }}>
      <span style={{ opacity: 0.55, fontSize: big ? '0.6em' : '0.85em', marginRight: 1 }}>$</span>
      {formatted}
    </span>
  );
}
